var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1491_2668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.22656 5.27344C2.22656 7.8784 4.21526 10.7046 5.97006 13.1469C6.38719 13.7271 6.78674 14.2829 7.13435 14.8043C7.21588 14.9266 7.35322 15 7.49997 15C7.64672 15 7.78406 14.9266 7.8656 14.8043C8.2132 14.2829 8.61275 13.7271 9.02988 13.1469C10.7847 10.7046 12.7734 7.8784 12.7734 5.27344C12.7734 2.36549 10.4079 0 7.5 0C4.59205 0 2.22656 2.36549 2.22656 5.27344ZM10.1367 5.27344C10.1367 6.72741 8.95397 7.91016 7.5 7.91016C6.04603 7.91016 4.86328 6.72741 4.86328 5.27344C4.86328 3.81946 6.04603 2.63672 7.5 2.63672C8.95397 2.63672 10.1367 3.81946 10.1367 5.27344Z",
    fill: "#4AACC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.03125C8.47081 7.03125 9.25781 6.24425 9.25781 5.27344C9.25781 4.30262 8.47081 3.51562 7.5 3.51562C6.52919 3.51562 5.74219 4.30262 5.74219 5.27344C5.74219 6.24425 6.52919 7.03125 7.5 7.03125Z",
    fill: "#4AACC5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1491_2668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.8307afb8cfaf9503d91c103a10a1b4de.svg";
export { ForwardRef as ReactComponent };